import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_STIDestUpdateReverseScan = _resolveComponent("STIDestUpdateReverseScan")!
  const _component_STIDestUpdateV1 = _resolveComponent("STIDestUpdateV1")!

  return (_ctx.isReverseScanSTIDest)
    ? (_openBlock(), _createBlock(_component_STIDestUpdateReverseScan, { key: 0 }))
    : (_openBlock(), _createBlock(_component_STIDestUpdateV1, { key: 1 }))
}